import { ColumnDef, ColumnSort } from "@tanstack/react-table";
import { formatMessage } from "i18n/CurrentLocale";
import { ColumnVisibility } from "screens/modals/ManageTableColumnsModal";


export const parkdCardsTableDefaultSorting: ColumnSort[] = [{ id: 'last4Digits', desc: true, }];

export const PARKD_CARDS_TABLE_DEFAULT_COLUMN_VISIBILITY: ColumnVisibility = {
    last4Digits: true,
    licensePlate: true,
    expiry: true
}

export const parkdCardsTableColumns: ColumnDef<any, any>[] = [
    {
        id: 'last4Digits',
        accessorKey: 'last4Digits',
        header: () => formatMessage({ id: 'COLUMN_CARD_LAST_4_DIGITS' }),
        cell: (info) => info.getValue() ? info.getValue() : '',
        enableColumnFilter: true
    },
    {
        id: 'licensePlate',
        accessorFn: (row) => row.licensePlate?.licensePlate ?? '',
        header: () => formatMessage({ id: 'COLUMN_CARD_LICENSE_PLATE' }),
        cell: (info) => info.getValue() ? info.getValue() : '',
        enableColumnFilter: true,
        enableSorting: false // not working
    },
    {
        id: 'expiry',
        accessorKey: 'expiry',
        header: () => formatMessage({ id: 'COLUMN_CARD_EXPIRY' }),
        cell: (info) => info.getValue() ? info.getValue() : '',
        enableColumnFilter: false
    }
]
